import { useTranslation } from "react-i18next";

const Problems = ({ direction }) => {
  const isRight = direction === "text-right";
  const { t } = useTranslation();

  const points = t("problemsSection.points", { returnObjects: true });

  return (
    <section id="problems" className="service padding-y-120 position-relative z-index-1">
      {/* <img
        src="/assets/images/gradients/featured-gradient.png"
        alt=""
        className="bg--gradient white-version"
      /> */}
      <div className="container container-two">
        <div
          className={`row gy-4 align-items-center flex-wrap ${isRight ? "flex-row-reverse flex-wrap-reverse" : ""
            }`}
        >
          <div className="col-xl-5 problemsImg">
            <img src="/assets/images/thumbs/problemsImg.webp" alt="" />
            <div className="problemsImg-text">
                        <img src="/assets/images/icons/n-icon.svg" alt="nomio" />
            </div>
          </div>
          <div className="col-xl-1 d-xl-block d-none" />
          <div className="col-xl-6">
            <div className="section-content">
              <div className="section-heading style-left">
                <h3 className="section-heading__title">{t("problemsSection.title")}</h3>
                <p className="section-heading__desc font-18 w-sm">
                  {t("problemsSection.desc")}
                </p>

                <ul>
                  {points.map((point, index) => (
                    <li className="custom-points" key={index}>
                      <img
                        src="/assets/images/icons/circle-tick.svg"
                        alt="Tick icon"
                        className="custom-points-icon"
                      />
                      <div>
                        <h5 className="service-item__title my-3">
                          {point.title}
                        </h5>
                        <p className="service-item__desc">
                          {point.desc}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;

